import { layerMetadataAtom } from '@app/domains/layers/state/layers.atoms'
import { getBaseLayerId } from '@app/domains/layers/utils/layers.utils'
import { HazardLayerMetadata } from '@app/types'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

/**
 * Returns the layer information and data quality details for a hazard layer
 *
 * Strips the asset tag to the base layer id (e.g. "h164_l0_v3" → "h164")
 * and looks it up in `layerMetadataAtom`.
 *
 * Returns the full `HazardLayerMetadata` object including owner, confidence rating,
 * description, limitations, source links, and suitability scores.
 * Returns `null` if no metadata is found for the given id.
 *
 * @param id - The asset tag of the layer (e.g. "h164_l0_v3")
 */
export const useHazardLayerMetadata = (id?: string): HazardLayerMetadata | null => {
  const layerMetadata = useAtomValue(layerMetadataAtom)

  return useMemo(() => {
    if (!id) return null
    return layerMetadata.find((m) => m.id === getBaseLayerId(id)) ?? null
  }, [id, layerMetadata])
}
